import {
  Modal as MUIModal,
  Typography,
  Button,
  Box,
  Stack,
  Link,
  TextareaAutosize,
} from "@mui/material";
import {
  ModalCloseIcon,
  RightArrowIcon,
  ThumbsDownIcon,
} from "../../@lib/icons";
import { useLanguageTranslator } from "../useLanguageContext";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 530,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  py: 3,
  px: 1,
};

function ConfirmationRejectModal({
  isOpen,
  handleClose,
  value,
  setValue,
  text = "",
  onClickHandler,
  viewPath = "",
  item,
}: any) {
  const { translator } = useLanguageTranslator();

  function handleChange(e: any) {
    setValue(e?.target?.value);
  }
  return (
    <div>
      <MUIModal
        open={isOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack
            sx={{ display: "flex", justifyContent: "end", alignItems: "end" }}
          >
            <Button
              onClick={handleClose}
              sx={{ padding: "0px", minWidth: "auto" }}
            >
              <ModalCloseIcon />
            </Button>
          </Stack>
          <Stack
            direction="column"
            sx={{ padding: "10px 60px" }}
            alignItems="center"
          >
            <ThumbsDownIcon />
            <Box width={"100%"}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", marginBottom: "8px" }}
              >
                {translator("Tell the reason of rejection")}
              </Typography>
              <TextareaAutosize
                minRows={3}
                maxRows={10}
                placeholder={`${translator(`rejectPlaceholder`)}...`}
                onChange={handleChange}
                value={value}
                style={{
                  width: "100%",
                  padding: "12px",
                  fontSize: "16px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  fontFamily: "inherit",
                  resize: "none",
                }}
              />
            </Box>
            <Typography id="modal-modal-title" sx={{ fontSize: "16px" }}>
              {translator(`rejectPopupMessage`, {
                text: translator(`confirmationItems.${text}`),
              })}
              ?
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="center" gap={1} mt={2}>
            <Button
              sx={{
                backgroundColor: "#FF6D6D",
                "&:hover": {
                  backgroundColor: "#CC4C4C",
                },
                color: "white",
                padding: "7px 50px",
              }}
              onClick={() => onClickHandler(item)}
            >
              {translator("status.Reject")}
            </Button>
            <Button
              onClick={handleClose}
              sx={{
                backgroundColor: "#989C9F",
                "&:hover": {
                  backgroundColor: "#D9534F",
                },
                color: "white",
                padding: "7px 50px",
              }}
            >
              {translator("Cancel")}
            </Button>
          </Stack>
          <Link
            id="modal-modal-description"
            href={viewPath}
            sx={{
              mt: 2,
              color: "#F6A000",
              fontSize: "14px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {translator(`footerTextReview`, {
              text: translator(`confirmationItems.${text}`),
            })}
            <div style={{ marginLeft: "10px" }}>
              <RightArrowIcon />
            </div>
          </Link>
        </Box>
      </MUIModal>
    </div>
  );
}

export { ConfirmationRejectModal };
